const colorNameToHex: Record<string, string> = {
  nero: '#1a1a1a', black: '#1a1a1a', scuro: '#1a1a1a',
  bianco: '#ffffff', white: '#ffffff',
  rosso: '#dc2626', red: '#dc2626',
  blu: '#2563eb', blue: '#2563eb', indaco: '#4f46e5', navy: '#1e3a8a',
  verde: '#16a34a', green: '#16a34a',
  giallo: '#eab308', yellow: '#eab308',
  arancione: '#ea580c', orange: '#ea580c',
  rosa: '#ec4899', pink: '#ec4899', fucsia: '#d946ef',
  viola: '#7c3aed', purple: '#7c3aed', lilla: '#a855f7',
  marrone: '#92400e', brown: '#92400e',
  grigio: '#6b7280', gray: '#6b7280', grey: '#6b7280',
  beige: '#e8dcc4',
  oro: '#d4af37', gold: '#d4af37',
  argento: '#c0c0c0', silver: '#c0c0c0',
  celeste: '#7dd3fc', azzurro: '#38bdf8', lightblue: '#7dd3fc',
  turchese: '#14b8a6', turquoise: '#14b8a6', teal: '#14b8a6',
  bordeaux: '#7f1d1d', burgundy: '#7f1d1d',
  crema: '#fff5e1', cream: '#fff5e1',
  avorio: '#fffff0', ivory: '#fffff0',
  lavanda: '#c4b5fd', lavender: '#c4b5fd',
  senape: '#ca8a04', mustard: '#ca8a04',
  corallo: '#f87171', coral: '#f87171',
  salvia: '#86efac', sage: '#86efac',
}

const colorKeywords: { re: RegExp; hex: string }[] = [
  { re: /\b(nero|black|scuro)\b/i, hex: '#1a1a1a' },
  { re: /\b(bianco|white)\b/i, hex: '#ffffff' },
  { re: /\b(rosso|red)\b/i, hex: '#dc2626' },
  { re: /\b(blu|blue|indaco|navy)\b/i, hex: '#2563eb' },
  { re: /\b(verde|green)\b/i, hex: '#16a34a' },
  { re: /\b(giallo|yellow)\b/i, hex: '#eab308' },
  { re: /\b(arancione|orange)\b/i, hex: '#ea580c' },
  { re: /\b(rosa|pink|fucsia)\b/i, hex: '#ec4899' },
  { re: /\b(viola|purple|lilla)\b/i, hex: '#7c3aed' },
  { re: /\b(marrone|brown)\b/i, hex: '#92400e' },
  { re: /\b(grigio|gray|grey)\b/i, hex: '#6b7280' },
  { re: /\b(beige)\b/i, hex: '#e8dcc4' },
  { re: /\b(oro|gold)\b/i, hex: '#d4af37' },
  { re: /\b(argento|silver)\b/i, hex: '#c0c0c0' },
  { re: /\b(celeste|azzurro|lightblue)\b/i, hex: '#7dd3fc' },
  { re: /\b(turchese|turquoise|teal)\b/i, hex: '#14b8a6' },
  { re: /\b(bordeaux|burgundy)\b/i, hex: '#7f1d1d' },
  { re: /\b(crema|cream)\b/i, hex: '#fff5e1' },
  { re: /\b(avorio|ivory)\b/i, hex: '#fffff0' },
  { re: /\b(lavanda|lavender)\b/i, hex: '#c4b5fd' },
  { re: /\b(senape|mustard)\b/i, hex: '#ca8a04' },
  { re: /\b(corallo|coral)\b/i, hex: '#f87171' },
  { re: /\b(salvia|sage)\b/i, hex: '#86efac' },
]

export function parseItemColors(colorField: string | null, fallbackText?: string): string[] {
  const hexes: string[] = []

  if (colorField?.trim()) {
    const parts = colorField.split(/[,/+]| e | and /i).map(s => s.trim()).filter(Boolean)
    for (const part of parts) {
      if (/^#[0-9a-f]{6}$/i.test(part)) {
        hexes.push(part)
        continue
      }
      const hex = colorNameToHex[part.toLowerCase()]
      if (hex) hexes.push(hex)
    }
  }

  return hexes.slice(0, 2)
}
